@if (form && definition) {
  <div
    class="flex flex-col"
    >
    <label class="soft-label soft-label-top"
      >{{ definition.title }}
      @if (definition.required | booleanRule: form.value) {
        <span
          class="required-indicator"
          >*</span
          >
        }
      </label>
      <soft-number-input
        [formControl]="form|formControl:definition.name"
        [readonly]="definition.readonly | booleanRule: form.value"
        [softScan]="(definition | scanDefinition)?.scan ?? false"
        [labelTypes]="(definition | scanDefinition)?.labelTypes"
        softFieldValidation
        #value
        >
      </soft-number-input>
    </div>
  }
